module.exports = __webpack_public_path__ + "img/carousel2.80cb63f3.png";